import React, { useMemo } from "react";
import {
    StyledLabelBox,
    StyledBackgroundDiv,
    StyledLabel,
    StyledTitle,
    StyledColumn,
    StyledRow,
    StyledLabelDiscount,
    StyledLabelContainer,
    StyledTitleContainer,
} from "./product-card.styled";
import PropTypes from "prop-types";
import { translateColor } from "@/helper/colors";
import { parseAmount } from "@/helper/parseAmount";

const ProductCard = ({ rectangleColor, label, title, price, discount, onClickHandler }) => {
    const discountPercent = useMemo(() => {
        if (!discount) return null;
        return ((parseFloat(discount) / parseAmount(price)) * 100).toFixed(0);
    });

    const discountedPriceStyle = {
        textDecoration: "line-through",
        color: "#dcdbdc",
        marginRight: "8px",
    };
    return (
        <StyledLabelBox onClick={onClickHandler}>
            <StyledLabelContainer>
                {discountPercent && <StyledLabelDiscount>{`${discountPercent}% OFF`}</StyledLabelDiscount>}
                {label && <StyledLabel>{label}</StyledLabel>}
            </StyledLabelContainer>
            <StyledRow>
                <StyledBackgroundDiv color={translateColor(rectangleColor)} />
                <StyledColumn>
                    <StyledTitle>{title}</StyledTitle>
                    <StyledTitleContainer>
                        <StyledTitle style={{ fontSize: "14px", ...(discountPercent ? discountedPriceStyle : {}) }}>
                            {`RD$ ${price}`}
                        </StyledTitle>
                        {discountPercent && <StyledTitle style={{ fontSize: "14px", color:"#78af1c" }}>
                            {`RD$ ${(parseAmount(price) - parseAmount(discount)).toFixed(2)}`}
                        </StyledTitle>}
                    </StyledTitleContainer>
                </StyledColumn>
            </StyledRow>
        </StyledLabelBox>
    );
};

ProductCard.propTypes = {
    rectangleColor: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.string,
    onClickHandler: PropTypes.func,
};

export default ProductCard;
